<template>
  <div>
    <div class="row my-2">
      <div class="col-sm-12 col-lg-6 col-md-6">
        <label>Areas highlighted in blue need correction</label>
      </div>
      <div class="col-sm-12 col-lg-6 col-md-6 align-right">
        <b-button
          :to="{
            name: previousRoute ,
          }"
          pill
          variant="outline-primary"
          >Return To Summary</b-button
        >
      </div>
    </div>
    <div class="row my-2">
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label>Upload User File</label>
        <div class="row my-2">
          <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
            <label
              >{{ FirstName + " " + LastName }} ( {{ NewUserName }} ) [
              <b-button
                @click="deleteUserRecords"
                pill
                size="sm"
                variant="outline-primary"
                >Delete</b-button
              >
              ]
            </label>
            <div class="row m-1">
              <div class="col-lg-2 col-md-2 border p-1">
                <label>First Name</label>
                <b-form-input v-model="FirstName"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Last Name</label>
                <b-form-input v-model="LastName"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Middle Name</label>
                <b-form-input v-model="MiddleName"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>User Name</label>
                <b-form-input v-model="NewUserName"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Active User</label>
                <b-form-select
                  v-model="ActiveUserYesNo"
                  :options="StatusOptionYesNo"
                ></b-form-select>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Admin</label>
                <b-form-select
                  v-model="IsAdminYesNo"
                  :options="StatusOptionYesNo"
                ></b-form-select>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Single Item</label>
                <b-form-select
                  v-model="SingleItemYesNo"
                  :options="StatusOptionYesNo"
                ></b-form-select>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Points</label>
                <b-form-input v-model="Points"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Address</label>
                <b-form-input v-model="Address"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Address 2</label>
                <b-form-input v-model="Address2"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>City</label>
                <b-form-input v-model="City"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>State</label>
                <b-form-input v-model="State"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Zip</label>
                <b-form-input v-model="Zip"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Daytime Phone</label>
                <b-form-input v-model="DaytimePhone"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Evening Phone</label>
                <b-form-input v-model="EveningPhone"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Company</label>
                <b-form-select v-model="Company">
                  <option
                    v-for="company in CompanyOptions"
                    :value="company"
                    :key="company.value"
                  >
                    {{ company.text }}
                  </option>
                </b-form-select>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Code</label>
                <b-form-input v-model="Code"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Code2</label>
                <b-form-input v-model="Code2"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Email Address</label>
                <b-form-input v-model="EmailAddress"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Social Security #</label>
                <b-form-input v-model="SSN"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Program</label>
                <b-form-select v-model="Program">
                  <option
                    v-for="program in ProgramOptions"
                    :value="program"
                    :key="program.key"
                  >
                    {{ program.text }}
                  </option>
                </b-form-select>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Transaction Comment</label>
                <b-form-input v-model="TransactionComment"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Email Message</label>
                <b-form-input v-model="EmailMessage"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Email Subject</label>
                <b-form-input v-model="EmailSubject"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Joining Date</label>
                <b-form-input
                  v-model="JoiningDate"
                  placeholder="MM/DD/YYYY"
                ></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Birth Day</label>
                <b-form-input v-model="BirthDay"></b-form-input>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Birth Year</label>
                <b-form-input v-model="BirthYear"></b-form-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-lg-2 col-md-2">
                <form v-on:submit.prevent="updateUserRecords()">
                  <input
                    class="btn btn-primary btn-lg btn-sm-block m-2"
                    type="submit"
                    name="update"
                    value="Update"
                  />
                </form>
              </div>
              <div class="col-sm-12 col-lg-2 col-md-2">
                <form v-on:submit.prevent="deleteUserRecords()">
                  <input
                    class="btn btn-primary btn-lg btn-sm-block m-2"
                    type="submit"
                    name="delete"
                    value="Delete This User"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UTCToLocale, localeToUTC } from "@/utilities/date.js";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapState } from "vuex";
import Modal from "@/components/Modal.vue";
import {
  convertToMonthDayYear,
  getCustomizedTimestamp,
  validateMonthDateYearFormat,
  validateYear,
} from "@/utilities/date.js";

export default {
  name: "BatchUserUploadToolEditPreviewInsertUsers",

  props: {
    activeMenuItem: String,
    activeMenu: String,
    operationType: String,
    uploadId: Number,
    previousRoute: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: Modal,
  },

  data() {
    return {
      UploadId: +this.$route.params.uploadId,
      StatusOptionYesNo: [
        { value: 1, text: "Yes" },
        { value: 0, text: "No" },
      ],
      FirstName: "",
      LastName: "",
      MiddleName: "",
      UserName: "",
      NewUserName: "",
      NewNewUserName: "",
      ActiveUserYesNo: 0,
      IsAdminYesNo: 0,
      SingleItemYesNo: 0,
      Points: 0,
      Address: "",
      Address2: "",
      City: "",
      State: "",
      Zip: "",
      DaytimePhone: "",
      EveningPhone: "",
      Company: null,
      CompanyOptions: [],
      Code: "",
      Code2: "",
      EmailAddress: "",
      SSN: "",
      Program: null,
      ProgramName: "",
      ProgramOptions: [],
      TransactionComment: "",
      EmailMessage: "",
      EmailSubject: "",
      JoiningDate: "",
      BirthDay: "",
      BirthYear: "",
      UserId: 0,
      DateCreated: "",
      CreatedBy: "",
      DateEdited: "",
      EditedBy: "",
      Password: "",
      NewPassword: "",
    };
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersBatchUserUploadTool",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },
    updateUserRecords: function() {
      const params = {
        upload_id: +this.UploadId,
        datecreated: this.DateCreated,
        created_by: this.CreatedBy,
        dateedited: this.DateEdited,
        edited_by: this.EditedBy,
        status: "OK",
        actiontype: this.operationType,
        username: this.UserName,
        new_username: this.NewUserName,
        password: this.Password,
        new_password: this.NewPassword,
        disabled: this.ActiveUserYesNo ? true : false,
        code: this.Code,
        code2: this.Code2,
        company_name: this.Company.text,
        client_Id: this.Company.value,
        points: +this.Points,
        administrator: +this.IsAdminYesNo,
        singleitem: this.SingleItemYesNo ? true : false,
        program_id: +this.Program?.value ?? 0,
        program_name: this.Program?.text ?? "",
        firstname: this.FirstName,
        middleinitial: this.MiddleName,
        lastname: this.LastName,
        address1: this.Address,
        address2: this.Address2,
        city: this.City,
        state: this.State,
        zip: this.Zip,
        dayphone: this.DaytimePhone,
        eveningphone: this.EveningPhone,
        email: this.EmailAddress,
        ssn: this.SSN,
        email_subject: this.EmailSubject,
        transaction_comments: this.TransactionComment,
        email_msg: this.EmailMessage,
        user_id: +this.UserId,
        joiningdate: validateMonthDateYearFormat(this.JoiningDate)
          ? getCustomizedTimestamp(this.JoiningDate)
          : null,
        birthday: this.BirthDay,
        birthyear: validateYear(this.BirthYear) ? this.BirthYear : "",
      };

      this.$store
        .dispatch("adminBatchUserUploadTool/updateUserRecordsByUploadId", {
          ...params,
          datecreated: localeToUTC(params.datecreated),
          dateedited: localeToUTC(params.dateedited),
        })
        .then((uploadId) => {
          // update AllUsersForPreview store
          this.$store.dispatch(
            "adminBatchUserUploadTool/fetchUsersForPreview",
            {
              operationType: "insert",
            }
          );

          // // open message box with msg: User has been updaed from the list of pending users.
          this.$store.dispatch("systemMessage/setModalMessage", {
            message: "User has been updated from the list of pending users.",
          });

          // // at last redirect to batch user upload tool
          this.$router.push({
            name: this.previousRoute //"AdminBatchUserUploadToolMain",
          });
        })
        .catch(() => {
          console.log("error while upload preview insert");
        });
    },

    deleteUserRecords() {
      this.$store
        .dispatch("adminBatchUserUploadTool/deleteUserRecordsByUploadId", {
          uploadId: +this.UploadId,
        })
        .then((status) => {
          // // update user summary
          this.$store.dispatch(
            "adminBatchUserUploadTool/fetchUserUploadSummary"
          );

          // // open message box with msg: User has been removed from the list of pending users.
          this.$store.dispatch("systemMessage/setModalMessage", {
            message: "User has been removed from the list of pending users.",
          });

          // // at last redirect to batch user upload tool
          this.$router.push({
            name: this.previousRoute //"AdminBatchUserUploadToolMain",
          });

          // scrolling to top
          this.scrollToTop();
        })
        .catch(() => {
          console.log("error from delete preview user records");
        });
    },
    scrollToTOp() {
      window.scrollTo(0, 0);
    },
    getAuthorizedClientsIdsForAllProgramsList() {
      if (this.authorizedClients.length > 0) {
        var clientsIds = [];

        this.authorizedClients.forEach((client) => {
          if (typeof client.clientId === "number") {
            clientsIds.push(client.clientId);
          }
        });

        return clientsIds.join();
      }
    },
  },

  computed: {
    authorizedClients() {
      return this.$store.getters["adminPointPrograms/getAuthorizedClients"];
    },
    authorizedProgrammes() {
      var programs = this.$store.getters[
        "adminBatchUserUploadTool/getAllClientsProgram"
      ];
      return programs;
    },
    getUserDetailForPreview() {
      return this.$store.getters[
        "adminBatchUserUploadTool/getSingleUserDetailForPreview"
      ];
    },
  },

  watch: {
    authorizedClients(authorizedClients) {
      var datas = [];
      authorizedClients.map(function(data) {
        datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      if (authorizedClients.length > 0) {
        // const clientIds = this.getAuthorizedClientsIdsForAllProgramsList();
        try {
          let clientIds = authorizedClients.map((client) => {
            return client.clientId;
          });
          console.log(clientIds);
          this.$store.dispatch("adminPointPrograms/fetchProgramsList", {
            client_ids: clientIds,
          });
        } catch (error) {
          console.log(error);
        }
      }

      this.CompanyOptions = datas;
    },
    getUserDetailForPreview(getUserDetailForPreview) {
      this.FirstName = getUserDetailForPreview.firstname;
      this.LastName = getUserDetailForPreview.lastname;
      this.MiddleName = getUserDetailForPreview.middleinitial;
      this.UserName = getUserDetailForPreview.username;
      this.NewUserName = getUserDetailForPreview.username;
      this.ActiveUserYesNo = getUserDetailForPreview.disabled ? 1 : 0;
      this.IsAdminYesNo = getUserDetailForPreview.administrator ? 1 : 0;
      this.SingleItemYesNo = getUserDetailForPreview.singleitem ? 1 : 0;
      this.Points = getUserDetailForPreview.points;
      this.Address = getUserDetailForPreview.address1;
      this.Address2 = getUserDetailForPreview.address2;
      this.City = getUserDetailForPreview.city;
      this.State = getUserDetailForPreview.state;
      this.Zip = getUserDetailForPreview.zip;
      this.DaytimePhone = getUserDetailForPreview.dayphone;
      this.EveningPhone = getUserDetailForPreview.eveningphone;
      this.Company = getUserDetailForPreview.client_id
        ? {
            value: Number(getUserDetailForPreview.client_id),
            text: getUserDetailForPreview.company_name,
          }
        : { value: null, text: "" };
      this.Code = getUserDetailForPreview.code;
      this.Code2 = getUserDetailForPreview.code2;
      this.EmailAddress = getUserDetailForPreview.email;
      this.SSN = getUserDetailForPreview.ssn;
      this.Program = getUserDetailForPreview.program_id
        ? {
            value: getUserDetailForPreview.program_id,
            text: getUserDetailForPreview.program_name,
          }
        : { value: null, text: "" };
      this.TransactionComment = getUserDetailForPreview.transaction_comments;
      this.EmailMessage = getUserDetailForPreview.email_msg;
      this.EmailSubject = getUserDetailForPreview.email_subject;
      this.JoiningDate = getUserDetailForPreview.joiningdate
        ? convertToMonthDayYear(getUserDetailForPreview.joiningdate)
        : "";
      this.BirthDay = getUserDetailForPreview.birthday;
      this.BirthYear = getUserDetailForPreview.birthyear;
      this.UserId = getUserDetailForPreview.userid;
      this.DateCreated = getUserDetailForPreview.datecreated;
      this.CreatedBy = getUserDetailForPreview.created_by;
      this.DateEdited = getUserDetailForPreview.dateedited;
      this.EditedBy = getUserDetailForPreview.edited_by;
      this.Password = getUserDetailForPreview.password
        ? getUserDetailForPreview.password
        : "";
      this.NewPassword = getUserDetailForPreview.new_password
        ? getUserDetailForPreview.new_password
        : "";
    },
    authorizedProgrammes(authorizedProgrammes) {
      if (this.Company) {
        this.Company = { ...this.Company };
      }
    },
    Company(company) {
      if (company?.value) {
        this.ProgramOptions =
          this.authorizedProgrammes
            .find(({ clientId }) => clientId === company.value)
            ?.authorizedClientsPrograms.map(({ programId, programName }) => ({
              value: programId,
              text: programName,
            })) ?? [];
      }
    },
  },

  created() {
    this.setActiveMenuItem();
    this.scrollToTOp();
    this.$store.dispatch("adminPointPrograms/fetchAuthorizedClients");
    this.$store.dispatch(
      "adminBatchUserUploadTool/fetchUserDetailForPreviewByUploadId",
      {
        uploadId: +this.UploadId,
      }
    );
    this.$store.dispatch("adminBatchUserUploadTool/fetchAllClientsProgram", {
      clientId: 0,
      status: "Active",
    });

    console.log("test: " + this.previousRoute)
  },
};
</script>

<style lang="scss" scoped>
.admin-batch-user-upload-tool {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}
</style>
